<template>
    <section class="c-intro">
        <slot>This is intro</slot>
    </section>
</template>

<script>
    export default {
        name: 'AppIntro',
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .c-intro {
        min-height: grid(1, lg);
        margin-bottom: grid(1);

        @include media-breakpoint-up(sm) {
            margin-bottom: grid(1, sm);
        }

        @include media-breakpoint-up(lg) {
            margin-bottom: grid(1, lg);
        }

        *:last-child {
            margin-bottom: 0;
        }

        &__title {
            margin-bottom: 0;

            @include media-breakpoint-down(xsl) {
                margin-bottom: grid(1) !important;
            }
        }
    }
</style>
